<!--
 * @Author: 谢树和 shuhe.xie@southgis.com
 * @Date: 2022-10-09 10:36:05
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @LastEditTime: 2022-11-01 11:35:51
 * @FilePath: \standard-v5\src\views\OpinionPublish\detail\Stage.vue
 * @Description: 意向发布 - 选择测绘阶段和测绘事项
-->

<template>
  <div class="stage">
    <div class="collapse">
      <div class="collapse-item" v-for="(item, i) in renderData" :key="i">
        <div class="title">
          <van-checkbox shape="square" v-model="item.checked" @change="toggleAll(i)"
           :class="{'half': item.result<item.children.length && item.result>0}" >
            {{ item.title }}
          </van-checkbox>
          <van-icon name="arrow-down" @click.native="handleExpand(i)" :style="{ transform: `rotate(${item.expand ? '0' : '180'}deg)`}" />
        </div>
        <div class="check-box" :style="{ height: `${item.expand ? (item.children.length*40)+'px' : '0px'}` }">
          <div class="check-group">
            <van-checkbox shape="square" :name="child.value" v-for="(child, c) in item.children" :key="c" 
              v-model="child.checked" @click="clickChild($event, i)">
              <div>{{ child.label }}</div>
              <van-popover
                v-model="child.showPopover"
                placement="left"
                trigger="click"
                theme="dark"
                :actions="[{ text: child.description }]"
              >
                <template #reference>
                  <van-icon name="question-o" @click.stop="clickIcon(child)" v-if="child.description" />
                </template>
              </van-popover>
            </van-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api/opinionPublish'
// import moduleMixins from '@/mixins/moduleMixins'
import { mapGetters } from 'vuex'
export default {
  components: {},
  // mixins: [ moduleMixins ],
  props: {},
  data() {
    return {
      renderData: [],
      activeNames: [],
      listData: [],
      componentData: {}
    };
  },
  watch: {},
  computed: {
    ...mapGetters('opinion', ['getOpinionData']),
    // navTitle() {
    //   return '选择测绘事项'
    // },
  },
  methods: {
    handleExpand(i) {
      this.renderData[i].expand = !this.renderData[i].expand
    },
    toggleAll(i) {
      let item = this.renderData[i]
      // console.log(i, this.renderData[i].checked)
      item.result = item.checked ? 4 : 0
      item.children.forEach(el => {
        el.checked = item.checked
      })
    },
    clickIcon(child) {
      console.log(child)
      child.showPopover = !child.showPopover
    },
    clickChild(e, i) {
      // let item = JSON.parse(JSON.stringify(this.renderData[i]))
      let item = Object.assign({}, this.renderData[i])
      console.log(e, i, item)
      item.result = 0
      item.children.forEach(el => {
        if(el.checked) item.result += 1
      })
      // if(item.result == item.children.length) {
      //   item.checked = true
      // } else {
      //   console.log(item)
      // }
      item.checked = item.result == item.children.length ? true : false
      this.$set(this.renderData, i, item)
    },
    getItemWithNote() {
      let completedData = this.getOpinionData(2).data.CLSX
      // let completedData = this.$parent.allData[2].data
      let keyArr = []
      console.log(completedData)
      if(completedData && JSON.stringify(completedData)!='{}') {
        completedData.forEach(item => {
          keyArr.push(item.key || item.CLSXCode)
        })
      }
      
      api.getItemWithNote({ xmddszq: '' }).then(res => {
        let data = res.data
        data.orders.forEach((el, i) => {
          let children = data[el]
          children.forEach(child => {
            // 返回上一步时赋值所选事项
            child.checked = keyArr.includes(child.key) ? true : false
            child.showPopover = false
          })
          let item = {
            title: el,
            expand: true,
            checked: false,
            result: 0,
            children
          }
          this.renderData.push(item)
          this.activeNames.push(i)
        }) 
      })
    }
  },
  created() {
    this.getItemWithNote()
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.stage {
  position: relative;
  .collapse {
    margin: 20px 16px;
    padding-bottom: 50px;
    &-item {
      margin-bottom: 20px;
      .title {
        box-sizing: border-box;
        width: 100%;
        padding: 10px 16px;
        overflow: hidden;
        color: #323233;
        font-size: 14px;
        line-height: 24px;
        background-color: #fff;
        position: relative;
        i {
          height: 24px;
          font-size: 16px;
          line-height: 24px;
          color: #969799;
          padding: 10px 20px;
          position: absolute;
          top: 0px;
          right: 0px;
          transition: all .3s ease-in-out;
        }
        &::after {
          position: absolute;
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          right: 16px;
          bottom: 0;
          left: 16px;
          border-bottom: 1px solid #ebedf0;
          transform: scaleY(.5);
        }
        .half {
          position: relative;
          ::v-deep .van-checkbox__icon::after {
            content: ' ';
            width: .6em;
            height: .6em;
            background-color: #1989fa;
            position: absolute;
            top: .2em;
            left: .2em;
          }
        }
      }
      .check-box {
        overflow: hidden;
        transition: height .3s ease-in-out;
        .check-group {
          padding: 12px 16px;
          color: #969799;
          font-size: 14px;
          line-height: 1.5;
          background-color: #fff;
          .van-checkbox {
            margin-bottom: 15px;
            ::v-deep .van-checkbox__label {
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: space-between;
              i {
                font-size: 20px;
              }
            }
          }
        }
      }
      
    }
  }
}
</style>
<style lang="scss">
.van-popup {
  .van-popover__action {
    width: 200px;
    min-height: 40px;
    height: auto;
    padding: 10px 16px;
  }
}
</style>